import _groupBy from 'lodash/groupBy';
import type { NotificationEventType } from '../types';

const isGroupSelected = ({
  events,
  preferences,
  channelType,
}: {
  events: NotificationEventType[];
  preferences: Record<string, Record<string, boolean>> | undefined;
  channelType: { id: string; name: string };
}) => Boolean(events.every((eventType) => preferences?.[eventType.id][channelType.id]));

const getGroupedEvents = ({ events }: { events: NotificationEventType[] }) =>
  _groupBy(events, (event) => event.group);

export const NotificationEvents = {
  getGroupedEvents,
  isGroupSelected,
};
